export const toReadableFormat = (str?: string) => {
  if (!str) return "Not Provided";

  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
